import React, { useState } from "react";
import ordersService from "../services/ordersService";

interface Props {
  orderId: string;
  onMessage: (type: string, text: string) => void;
}

function DownloadEpsZipLink({ orderId, onMessage }: Props): React.ReactElement {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);

    try {
      const response = await ordersService.downloadEpsZip(orderId);

      if (response.status !== 200) {
        throw new Error(`Invalid response status: ${response.status}`);
      }

      // Convert to Blob and create temporary URL
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);

      // Create temporary link and trigger click
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `order-${orderId}-eps.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Cleanup temporary URL
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(`Failed to download EPS ZIP: ${err}`);
      onMessage("danger", "EPS-tiedostojen lataus epäonnistui");
    } finally {
      setLoading(false);
    }
  };

  return (
    <a href="#" onClick={handleDownload}>
      {loading ? "Ladataan..." : "Lataa kaikki"}
    </a>
  );
}

export default DownloadEpsZipLink;
